<template>
  <div>
    <v-card-subtitle><h3>Выбор типа геометрии</h3></v-card-subtitle>
    <v-card-text class="pb-0">
      <custom-select
        :data="settings.type"
        :list="typeList"
        label="Тип геометрии"
        @change="onTypeChange"
      />
    </v-card-text>
    <template v-if="isPoint">
      <v-card-subtitle><h3>Настройка отображения точек</h3></v-card-subtitle>
      <point-view-settings
        :icon="icon"
        :view-style="settings.style"
        :mappings="settings.mappings"
      />
    </template>
    <template v-if="isLine">
      <v-card-subtitle><h3>Настройка отображения линий</h3></v-card-subtitle>
      <line-view-settings
        :view-style="settings.style"
        :mappings="settings.mappings"
      />
    </template>
    <template v-if="isPolygon">
      <v-card-subtitle><h3>Настройка отображения полигонов</h3></v-card-subtitle>
      <polygon-view-settings
        :view-style="settings.style"
        :mappings="settings.mappings"
      />
    </template>

    <reference-properties
      :settings="settings"
    />

    <v-card-subtitle><h3>Отображение надписей элементов</h3></v-card-subtitle>
    <v-card-text>
      <v-checkbox
        :input-value="settings.hasSymbolText"
        class="mt-0"
        label="Отображать надпись элементов"
        hide-details
        @change="toggleHasSymbolText"
      />
      <symbol-text-settings
        v-if="settings.hasSymbolText"
        :view-style="settings.symbol"
        :mappings="settings.mappings"
      />
    </v-card-text>
  </div>
</template>

<script>
import * as defaultStyles from '@/utils/styles';
import * as types from '@/constants/layer-types';
import PointViewSettings from '@/components/page/layers/settings/PointViewSettings.vue';
import LineViewSettings from '@/components/page/layers/settings/LineViewSettings.vue';
import PolygonViewSettings from '@/components/page/layers/settings/PolygonViewSettings.vue';
import ReferenceProperties from '@/components/page/layers/settings/ReferenceProperties.vue';
import SymbolTextSettings from '@/components/page/layers/settings/SymbolTextSettings.vue';
import CustomSelect from '@/components/ui/custom-select';

export default {
  name: 'view-settings',

  components: {
    CustomSelect,
    PointViewSettings,
    LineViewSettings,
    PolygonViewSettings,
    ReferenceProperties,
    SymbolTextSettings,
  },

  props: {
    settings: {
      type: Object,
      required: true,
    },

    typeList: {
      type: Array,
      required: true,
    },

    icon: {
      type: Object,
      default: null,
    },
  },

  computed: {
    isPoint() {
      return this.settings.type === types.POINT;
    },

    isLine() {
      return this.settings.type === types.LINE;
    },

    isPolygon() {
      return this.settings.type === types.POLYGON;
    },
  },

  methods: {
    toggleHasSymbolText() {
      this.settings.hasSymbolText = !this.settings.hasSymbolText;

      if (this.settings.hasSymbolText) {
        this.settings.symbol = defaultStyles.symbolStyle();
      } else {
        delete this.settings.symbol;
      }
    },

    onTypeChange(type) {
      if (this.settings.type !== type) {
        this.settings.type = type;

        switch (type) {
          case types.LINE:
            this.settings.style = defaultStyles.lineStyle();
            break;
          case types.POLYGON:
            this.settings.style = defaultStyles.polygonStyle();
            break;
          case types.POINT:
          default:
            this.settings.style = defaultStyles.pointStyle();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
